/** Telegram first-party Mini Apps are served from this host and only allow embedding on web.telegram.org. */
export function isTelegramInternalWebAppUrl(raw?: string): boolean {
  if (!raw) return false;
  try {
    const host = new URL(raw).hostname.toLowerCase();
    return host === 'webappinternal.telegram.org'
      || host === 'web.telegram.org'
      || host.endsWith('.web.telegram.org');
  } catch {
    return false;
  }
}

export function describeWebAppEmbed(raw?: string, isSameOrigin?: boolean) {
  let host = '';
  try {
    host = raw ? new URL(raw).hostname : '';
  } catch {
    host = '';
  }
  return {
    host,
    isSameOrigin: Boolean(isSameOrigin),
    cannotEmbed: Boolean(isSameOrigin) || isTelegramInternalWebAppUrl(raw),
  };
}
